import React, { useState, useEffect } from "react";
import { Paginator } from "../../../layout/Paginator/Paginator";
import { Search } from "../../../layout/Table/Search";
import { TableComponent } from "../../orderManagement/table/Table";
import { Messages } from "../../../../components/layout/Messages/Messages";
import { NOTIFICATION_ORDER_ACTIONS } from "../../../../config/notifications";
import { ACL } from '../../../../config/constants';
import { RowsPerPage } from "../../../layout/Table/RowsPerPage";
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';
import { ListToolbar } from '../../../layout/Workspace';

function ClientOrdersTab(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const {user, getUserOrders, orders, meta, rowsPerPageOrders, setRowsPerPageOrders} = props;
  const shouldRenderFields = false;

  useEffect( () => {
    if (user && getUserOrders) {
      getUserOrders(user.id, 1, sortField, sortDirection, searchText);
    }

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPageOrders] );

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getUserOrders(user.id, meta.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <section className="user-detail-section">
      <div className="user-detail-section__messages">
        <Messages/>
        <Messages notificationId={NOTIFICATION_ORDER_ACTIONS}/>
      </div>
      <ListToolbar
        className="user-detail-list-toolbar"
        search={ACL.CLIENT.ORDERS.SEARCH.hasAccess() ? (
          <Search
              search={(searchText) => {
                setSearchText(searchText);
                getUserOrders(user.id, 1, null, null, searchText, true);
              }}
              id="orders"
          />
        ) : null}
      />
      <div className="user-detail-table">
        <TableComponent
          shouldRenderFields={shouldRenderFields}
          applySort={(sortField) => applySort(sortField)}
          orders={orders}
          actionCallback={(useState) => {
            if (useState) {
              getUserOrders(
                user.id,
                meta.current_page,
                sortField,
                sortDirection,
                searchText
              );
            }
            getUserOrders(user.id);
          }}
        />
      </div>
      <Paginator
        meta={meta}
        settings={(
          <RowsPerPage
            changeRowsPerPage={(rowsPerPage) => {
              setRowsPerPageOrders(rowsPerPage);
            }}
            id="orders"
          />
        )}
        changePage={(page) =>
          getUserOrders(user.id, page, sortField, sortDirection, searchText, true)
        }
      />
    </section>
  );
}

export { ClientOrdersTab };
